angular.module('pulseApp').config(function($stateProvider, $urlRouterProvider) {
    
    $stateProvider.state('providerDashboard', {
        url: '/providerDashboard/:id',
        controller: 'ProviderDashboardCtrl as vm',
        templateUrl: 'app/view/providerDashboard/providerDashboard.html',
    });    

}).controller('ProviderDashboardCtrl', function ($scope) {
 
    var vm = this;
    var destroy = $scope.$on("$destroy", function () {
        //Cleanup anything that would persist beyond destruction, including $on/$watch
        destroy();
    });
});